/**
 * SettingsDialog.tsx — authenticated Settings modal (Phase 2.3, T4)
 *
 * A thin, controlled Radix Dialog wrapper hosting the (unit-tested)
 * ChangePasswordForm. Opened from the TopBar account menu. Built as an
 * extensible settings surface — for now it hosts only change-password (YAGNI);
 * future account/plan settings slot in as additional sections.
 *
 * The dialog content is portaled (jsdom can't see it), so the testable logic
 * deliberately lives in ChangePasswordForm, not here.
 */
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { ChangePasswordForm } from './ChangePasswordForm'

interface SettingsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SettingsDialog({ open, onOpenChange }: SettingsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Settings</DialogTitle>
          <DialogDescription>Manage your account.</DialogDescription>
        </DialogHeader>
        <section>
          <h3 className="mb-3 text-sm font-medium text-foreground">Change password</h3>
          <ChangePasswordForm onSuccess={() => undefined} />
        </section>
      </DialogContent>
    </Dialog>
  )
}
